<template>
  <v-col :cols="field.cols" class="py-0">
<!-- input text -->
    <v-text-field
      outlined
      color="blue darken-2"
      :label="field.lable"
      v-model="inputvalue"
      @input="$emit('input', inputvalue)"
      v-if="field.inputtype === 'text'"
      :rules="field.required ? [v => !!v || `${field.lable} is required`] : []"
    />

<!-- date picker -->
    <v-menu
      v-model="menu"
      min-width="auto"
      :nudge-right="40"
      transition="scale-transition"
      :close-on-content-click="false"
      v-if="field.inputtype === 'date'"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-text-field
          outlined
          readonly
          v-on="on"
          v-bind="attrs"
          :label="field.lable"
          v-model="inputvalue"
          prepend-inner-icon="mdi-calendar"
          :rules="field.required ? [v => !!v || `${field.lable} is required`] : []"
        />
      </template>
      <v-date-picker
        v-model="inputvalue"
        @input="menu = false"
        @change="$emit('input', inputvalue)"
      />
    </v-menu>
<!-- dropdown list -->
    <v-select
      outlined
      :items="itemList"
      :label="field.lable"
      v-model="inputvalue"
      :item-text="field.itemText"
      :item-value="field.itemValue"
      @change="$emit('input', inputvalue)"
      v-if="field.inputtype === 'select'"
      :rules="field.required ? [v => !!v || `${field.lable} is required`] : []"
    />
  </v-col>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'TextField',
  props: ['field', 'value'],
  data() {
    return {
      inputvalue: '',
      menu: false,
      itemList: [],
    };
  },
  watch: {
    value(v) {
      this.inputvalue = v;
    },
  },
  mounted() {
    this.inputvalue = this.value;
    if (this.field.inputtype === 'select') {
      this.fetchList();
    }
  },
  methods: {
    ...mapActions('sales', ['getRecords']),
    async fetchList() {
      this.itemList = await this.getRecords(this.field.element);
    },

  },
};
</script>
